import { render, staticRenderFns } from "./slpa-instructions.vue?vue&type=template&id=f68718e4&"
import script from "./slpa-instructions.vue?vue&type=script&lang=js&"
export * from "./slpa-instructions.vue?vue&type=script&lang=js&"
import style0 from "./slpa-instructions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "slpa-instructions.vue"
export default component.exports